module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--s1-a4695a54c25645dcf5ddf2300372bfb7.svg";